






















import {Component, Prop, Vue} from 'vue-property-decorator';
import {userStore} from "@/store/store";
import {dateTimeDisplay} from "@/lib/util/dateFunctions";
import {AsphaltDesignMetric, IAsphaltDesignImperial} from "@/modules/design/interfaces/newAsphalt";
import {UnitSystem} from "@/interfaces/units";
import {ILayerDef} from "@/modules/design/interfaces/shared";

@Component
export default class LayersReport extends Vue {

  @Prop() scenario!: IAsphaltDesignImperial | AsphaltDesignMetric;

  @Prop() layers!: ILayerDef[];

  @Prop() thicknessMultiplier!: number;

  formatDate = dateTimeDisplay;

  get user() {
    return userStore.user
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  get thicknessUnit() {
    return this.isImperial ? 'in' : 'cm'
  }

}
